/**
 * Find the first slide that overflows the left side of the slides container.
 */
export const findFirstOverflowedSlideFromLeft = (
    slidesListPosition: DOMRect,
    slides: NodeListOf<HTMLElement>
): DOMRect | undefined => {
    for (let i = slides.length - 1; i >= 0; i--) {
        const slideRect = slides[i].getBoundingClientRect();
        if (slidesListPosition.left > slideRect.left) {
            return slideRect;
        }
    }
};

/**
 * Find the first slide that overflows the right side of the slides container.
 */
export const findFirstOverflowedSlideFromRight = (
    slidesListPosition: DOMRect,
    slides: NodeListOf<HTMLElement>
): DOMRect | undefined => {
    const result = Array.from(slides).find((slide) => slidesListPosition.right < slide.getBoundingClientRect().right);

    return result?.getBoundingClientRect();
};

/**
 * Find the second slide inside the slides container.
 */
export const findSecondVisibleSlideFromTheLeft = (
    slidesListPosition: DOMRect,
    slides: NodeListOf<HTMLElement>
): DOMRect | undefined => {
    const result = Array.from(slides).find((slide) => slide.getBoundingClientRect().left > slidesListPosition.left);

    return result?.getBoundingClientRect();
};

/**
 * Find the first visible slide from left
 */
export const findFirstVisibleSlideFromLeft = (
    slidesListPosition: DOMRect,
    slides: HTMLCollection | never[]
): Element | undefined | null => {
    const secondVisibleSlideFromLeft = Array.from(slides).find(
        (slide) => slide.getBoundingClientRect().left > slidesListPosition.left
    );

    return secondVisibleSlideFromLeft?.previousElementSibling;
};

/**
 * Find the first visible slide from right
 */
export const findFirstVisibleSlideFromRight = (
    slidesListPosition: DOMRect,
    slides: HTMLCollection | never[]
): Element | undefined | null => {
    const firstOverflowedSlideFromRight = Array.from(slides).find(
        (slide) => slide.getBoundingClientRect().left > slidesListPosition.right
    );

    if (!firstOverflowedSlideFromRight) {
        return slides[slides.length - 1];
    }

    return firstOverflowedSlideFromRight?.previousElementSibling;
};

/**
 * Sets canScroll state according to carousel track position.
 */
export const setCanScrollByPosition = (isTrackOnPosition: boolean, setCanScroll: (canScroll: boolean) => void) => {
    if (isTrackOnPosition) {
        setCanScroll(false);
    } else {
        setCanScroll(true);
    }
};
